import React from "react"
import PropTypes from "prop-types"
import Img from "gatsby-image"

import styles from "./Image.module.css"

const Image = props => {
  const { alt, className, full } = props
  const ImageClasses = `${full && styles.fullImage} ${className}`
  return <Img {...props} className={ImageClasses} alt={alt} />
}

Image.propTypes = {
  className: PropTypes.string,
  alt: PropTypes.string,
  full: PropTypes.bool,
}

export default Image
